// card-product.liquid includes this once per card; the flag keeps it to a single init.
if (!window.bpCardHoverInit) {
  window.bpCardHoverInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.media--hover-effect').forEach((media) => {
      const images = media.querySelectorAll('img');
      if (images.length <= 1) return;

      let showingSecondary = false;
      let resetTimer = null;

      media.addEventListener('click', function (e) {
        const firstImage = this.querySelector('img:first-of-type');
        const lastImage = this.querySelector('img:last-of-type');
        if (!firstImage || !lastImage) return;

        if (!showingSecondary) {
          // First tap shows the secondary image instead of navigating
          e.preventDefault();
          e.stopPropagation();
          firstImage.style.opacity = '0';
          lastImage.style.opacity = '1';
          showingSecondary = true;

          clearTimeout(resetTimer);
          resetTimer = setTimeout(() => {
            firstImage.style.opacity = '1';
            lastImage.style.opacity = '0';
            showingSecondary = false;
          }, 3000);
        } else {
          showingSecondary = false;
        }
      });

      const card = media.closest('.card-wrapper');
      if (!card) return;

      card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (!showingSecondary) return;
          e.preventDefault();
          showingSecondary = false;
          const firstImage = media.querySelector('img:first-of-type');
          const lastImage = media.querySelector('img:last-of-type');
          if (firstImage && lastImage) {
            firstImage.style.opacity = '1';
            lastImage.style.opacity = '0';
          }
        });
      });
    });
  });
}
